export default {
  methods: {
    triggerPrintMode(printModeClass) {
      if (!printModeClass) return;
      this.enablePrintMode(printModeClass);
      if (this._printModeAfterPrintHandler) {
        window.removeEventListener("afterprint", this._printModeAfterPrintHandler);
      }
      this._printModeAfterPrintHandler = () => this.handleAfterPrint(printModeClass);
      window.addEventListener("afterprint", this._printModeAfterPrintHandler);
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          window.print();
        });
      });
    },
    enablePrintMode(printModeClass) {
      document.documentElement.classList.add(printModeClass);
      document.body.classList.add(printModeClass);
      const app = document.getElementById("app");
      if (app) {
        app.classList.add(printModeClass);
      }
    },
    cleanupPrintMode(printModeClass) {
      if (!printModeClass) return;
      document.documentElement.classList.remove(printModeClass);
      document.body.classList.remove(printModeClass);
      const app = document.getElementById("app");
      if (app) {
        app.classList.remove(printModeClass);
      }
      if (typeof this.cleanupPrintResources === "function") {
        this.cleanupPrintResources();
      }
    },
    handleAfterPrint(printModeClass) {
      this.cleanupPrintMode(printModeClass);
      if (this._printModeAfterPrintHandler) {
        window.removeEventListener("afterprint", this._printModeAfterPrintHandler);
        this._printModeAfterPrintHandler = null;
      }
    }
  }
};

